import { render } from "./Projects_workflow.vue?vue&type=template&id=00a68af2"
import script from "./Projects_workflow.vue?vue&type=script&lang=js"
export * from "./Projects_workflow.vue?vue&type=script&lang=js"

import "./Projects_workflow.vue?vue&type=style&index=0&id=00a68af2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__